import React, { useState } from 'react';
import { Alert, Box, Button } from '@mui/material';

const DISMISS_KEY = 'klinvia-dismiss-desktop-site-hint';

interface Props {
  show: boolean;
}

const MobileDesktopModeBanner: React.FC<Props> = ({ show }) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (!show || dismissed) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (t) => t.zIndex.snackbar + 2,
        px: 1,
        pt: 'max(env(safe-area-inset-top, 0px), 4px)',
      }}
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={() => {
          try {
            sessionStorage.setItem(DISMISS_KEY, '1');
          } catch {
            /* noop */
          }
          setDismissed(true);
        }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => window.location.reload()}
            sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}
          >
            Recarregar
          </Button>
        }
        sx={{ alignItems: 'flex-start', '& .MuiAlert-message': { fontSize: 13, lineHeight: 1.45 } }}
      >
        <strong>Site para computador</strong> está ativo no celular. Desative no menu do navegador (⋮ → desmarcar
        &quot;Site para computador&quot;) e recarregue para melhor zoom e toque. O layout mobile já está sendo
        aplicado.
      </Alert>
    </Box>
  );
};

export default MobileDesktopModeBanner;
